import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { DocumentService } from 'src/app/shared/services/simple/document.service';
import { DocumentModel } from 'src/app/shared/models/simple-types/document.model';
import { ModalAddBpDocumentComponent } from '../modals/modal-add-bp-document/modal-add-bp-document.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { OnChanges } from '@angular/core';
import { BpComponentsService, DetailBpinfos } from '../bp-components.service';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { BcComponentsService } from '../../bc/bc-components.service';
import { ModalShowBpDocumentComponent } from '../modals/modal-show-bp-document/modal-show-bp-document.component';
import { ModalGooglePickerComponent } from '../../bc/modals/modal-google-picker/modal-google-picker.component';
import { BpLineModel } from 'src/app/shared/models/societe-linked/bp/bp-line.model';

@Component({
  selector: 'app-bp-form',
  templateUrl: './bp-form.component.html',
  styleUrls: ['./bp-form.component.scss']
})
export class BpFormComponent implements OnChanges, OnInit {

  @Input() form: UntypedFormGroup;
  @Input() detailInfo: DetailBpinfos;
  @Input() amountHT: number;
  @Input() amountTVA: number;
  @Input() amountTTC: number;

  @Output() uploadDocument = new EventEmitter<DocumentModel[]>();
  showDocuments: boolean;
  documents: DocumentModel[];
  idBp: number;
  bpData: BpModel;
  CREATION = true;
  VALIDATION = false;
  VISUALISATION = false;
  dDProvis = null;
  minRows = 8;
  documentSubscriber: Subscription;
  constructor(
    private bcComponentsService: BcComponentsService,
    private documentService: DocumentService,
    public dialog: MatDialog,
    private bpComponentsService: BpComponentsService,
    public router: Router
  ) {

  }

  ngOnInit(): void {
    this.CREATION = this.router.url.includes('create-bp');
    this.bpComponentsService.loadDetailBp().subscribe((infos: DetailBpinfos) => {
      this.detailInfo = infos;
    });
    this.bpData = this.bpComponentsService.getCreatedBp();
    this.VALIDATION = this.router.url.includes('validate-bp');
    this.VISUALISATION = this.router.url.includes('read-bp');

  }

  ngOnChanges(): void {
    if (this.form && this.form.get('id').value && !this.documentSubscriber) {
      this.idBp = this.form.get('id').value;
      this.documentSubscriber = this.documentService.getAllFromBp(this.idBp).subscribe(docs => {
        this.documents = docs;
        this.uploadDocument.emit(this.documents);
      });
      this.showDocuments = true;
      if(this.form.get('status').value === "Clos") {
        this.minRows = 5.5
      }
      var bplines = this.form.get('bpLines').value
      if(bplines && bplines.length > 0){
        this.dDProvis = this.calculMaxDateProvis(bplines);
      }
    }
  }

  calculMaxDateProvis(bplines: BpLineModel[]): Date{
    var max = bplines[0].dDprovis;
    for(var bpline of bplines){
      if(bpline.dDprovis){
        if(bpline.dDprovis > max)
        {
          max = bpline.dDprovis;
        }
      }
    }
    return max;
  }

  getStyle(code: string, lib: string): boolean {
    if (this.VALIDATION) {
      if (lib === '') {
        if (this.form.get(code) && this.form.value.bpLines[0]) {
          if (this.form.get(code).value !== this.form.value.bpLines[0].bcLigne.bc[code]) {
            return true;
          }
        }
      } else {
        if (this.form.get(code).value && this.form.value.bpLines[0]) {
          if ((this.form.get(code).value !== this.form.value.bpLines[0].bcLigne.bc[code]
          || this.form.get(lib).value !== this.form.value.bpLines[0].bcLigne.bc[lib])) {
          return true;
        }
        }
      }
    }
    return false;
  }

  showBcDocuments(): void {
    this.dialog.open(ModalShowBpDocumentComponent, {
      data: {
        idBp: this.idBp,
        bp: this.form,
        documents: this.documents
      }
    });
  }

  showAddDocument(): void {
    this.dialog.open(ModalAddBpDocumentComponent, {
      data: {
        idBp: this.idBp,
        documents: this.documents
      }
    }).afterClosed().subscribe(res => {
      this.documentService.getAllFromBp(this.idBp).subscribe(docs => {
        this.documents = docs;
        this.uploadDocument.emit(this.documents);
      });
    });
  }

  showAddDriveDocument(): void {
    this.dialog.open(ModalGooglePickerComponent, {
      data: {
        id: this.form.get('id').value,
        type: 'BP'
      }
    }).afterClosed().subscribe(res => {
      this.documentService.getAllFromBp(this.idBp).subscribe(docs => {
        this.documents = docs;
        this.uploadDocument.emit(this.documents);
      });
    });
  }
}

